<script>
    import Vue from "vue";
    import $ from "jquery";
    import draggable from 'vuedraggable';
    import Block from './components/Block.vue';
    import Spacer from './components/Spacer.vue';
    import Container from './components/Container.vue';
    import Columns from './components/Columns.vue';
    import Preview from './components/Preview.vue';
    import defaultComponents from './DefaultComponents.vue'

    export default {
        name: 'TemplatesApp',
        components: {'draggable': draggable, 'block': Block, 'container': Container, 'columns': Columns, 'spacer': Spacer, 'preview': Preview},
        data: function() {
            return {
                styleWriter: null,
                idCounter: 1000,
                palette: [],
                undoHistory: [],
                timeout: null,
                delayTimers: {},
                emoji: [],
                css: '',
                wrapper: '',
                notchanged: true,
                draggedId: null,
                editorActive: false,
                blocks: [],
                tree: [],
                activeTab: 0,
                activeSubTab: 'common',
                blocksjson: '{}',
                currentBlock: null,
                hoveredColor: null,
                componentRefs: {},
                componentsRegistered: [],
                componentsAvailable: [],
                allComponents: [],
                availableStyles: [
                    'align', 'width', 'height', 'borderRadius', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight',
                    'borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderStyle', 'borderColor',
                    'backgroundImage', 'backgroundColor', 'backgroundRepeat', 'backgroundSize',
                ],
            }
        },
        watch: {
            wrapper: {
                handler: function() {
                    const app = this;

                    clearTimeout(app.delayTimers['wrapper']);

                    app.delayTimers['wrapper'] = setTimeout(function() {
                        app.registerWrapper();
                    }, 1000)
                }
            },
            css: {
                handler: function() {
                    this.applyTemplateStyles();
                }
            },
            blocks: {
                handler: function(val) {
                    let dt = {};
                    for (let item of val){
                        dt[item.name] = {
                            'idCounter': this.idCounter, 
                            'description': item.description,
                            'styles': item.styles,
                            'defaultStyles': item.style,
                            'defaultBgImage': item.bgImage,
                            'icon': item.icon,
                            'template': item.template,
                            'default': item.tree
                        }
                    }

                    this.blocksjson = JSON.stringify(dt);
                },
                deep: true
            },
        },
        mounted: function() {
            let blocks = {};
            let app = this;
            let idCounter = 1;

            this.styleWriter = document.createElement("style");
            document.body.appendChild(this.styleWriter);

            if (this.$refs.blocks.dataset.value) {
                blocks = JSON.parse(this.$refs.blocks.dataset.value);
            }

            if (this.$refs.palette.dataset.value) {
                this.palette = JSON.parse(this.$refs.palette.dataset.value);
            }

            if (this.$refs.css.dataset.value) {
                this.css = this.$refs.css.dataset.value;
            }

            this.applyTemplateStyles();

            if (this.$refs.wrapper.dataset.value) {
                this.wrapper = this.$refs.wrapper.dataset.value;
            }

            this.componentsRegistered = [...defaultComponents];
            this.componentsAvailable = [...defaultComponents];
            this.allComponents = [...defaultComponents];

            for(let [key, value] of Object.entries(blocks)) {
                let st = {
                    'id': idCounter,
                    'name': key,
                    'type': key,
                    'description': value.description,
                    'styles': value.styles,
                    'style': value.defaultStyles,
                    'bgImage': value.defaultBgImage,
                    'icon': value.icon,
                    'template': value.template,
                    'registered': true,
                    'tree': value.default || [[]]
                }
                if (value.idCounter) {
                    this.idCounter = value.idCounter; 
                }
                this.blocks.push({...st});
                this.componentsRegistered.push({...st});
            }

            idCounter++;


            this.registerComponents();
            this.registerWrapper();

            if (this.blocks.length > 0) {
                this.currentBlock = 0;
            }
            this.emoji = [...this.emoji];
        },
        methods: {
            reregisterComponents: function(cname) {
                const app = this;
                clearTimeout(app.delayTimers[cname]);
                app.delayTimers[cname] = setTimeout(function() {
                    app.componentsRegistered = [...defaultComponents];
                    for(let block of app.blocks) {
                        app.componentsRegistered.push({...block});
                    }
                    app.notchanged = false;
                    for (let component of app.blocks) {
                        delete Vue.options.components[component.name];
                    }
                    app.registerComponents();
                    app.registerWrapper();

                    app.notchanged =  true;
                }, 1000);
            },
            submitData: function(e) {
                e.preventDefault();
                this.$refs.templateForm.click();
            },
            addColor: function() {
                this.palette.push('#ffffff');
            },
            removeColor: function(e, index) {
                this.palette.splice(index, 1);
            },
            setColor: function(e, index) {
                this.hoveredColor = index;
            },
            unsetColor: function(e, index) {
                this.hoveredColor = null;
            },
            addBlock: function() {
                this.blocks.push({
                    'id': this.blocks.length,
                    'name': 'component'+this.blocks.length,
                    'type': 'component'+this.blocks.length,
                    'description': '',
                    'styles': [],
                    'icon': null,
                    'style': {},
                    'template': '',
                    'tree': [],
                    'bgImage': null,
                    'registered': true,
                });
                this.currentBlock = this.blocks.length-1;
                this.activeSubTab = 'common';
            },
            removeBlock: function(e, index) {
                let app = this;
                this.$dialog.confirm('Удалить компонент?').then(
                    function(dialog) {
                        app.blocks.splice(index, 1);
                        app.currentBlock = index > 0 ? index-1 : (index + 1 < app.blocks.length ? index + 1 : 0);
                    }
                ).catch(
                    function() {
                    }
                );
            },
            setBlock: function(e, index) {
                if (this.currentBlock == index) {
                    return;
                }
                this.currentBlock = index;
            },
            processFile: function(e, index) {
                let app = this;
                let reader  = new FileReader();

                if (e.target.files.length > 0) {
                    reader.readAsDataURL(e.target.files[0]);
                }

                reader.onloadend = function () {
                    app.blocks.splice(index, 1, {...app.blocks[index], icon: reader.result});
                }
            },
            updateDefaults: function(index, values) {
                this.blocks[index].style = values;
            },
            selectAll: function(index) {
                this.blocks[index]['styles'] = [...this.availableStyles];
            },
            unselectAll: function(index) {
                this.blocks[index]['styles'] = [];
            },
            lock: function() {

            },
            unlock: function() {

            },
            removeComponent: function(id) {
                this.updateComponent(id, null, 'remove');
            },
            duplicateComponent: function(id, data) {
                this.updateComponent(id, data, 'duplicate');
            },
            focusComponent: function(id) {
                this.editorActive = id;
            },
            unfocusComponent: function(id) {
                this.editorActive = false;

                if (this.componentChanged) { 
                    this.syncUndoBuffer();
                }
            },
            dragStart: function(id, name, event) {
                this.draggedType = name;
                this.draggedId = id;
            },
            dragEnd: function(event) {
                this.draggedType = null;
                this.draggedId = null;
            },
            clone: function(item) {
                let cloned = {
                    id: this.newId(),
                    type: item.type,
                    registered: true,
                    description: item.description,
                    styles: item.styles || [],
                    style: item.style || {},
                    bgImage: null,
                    tree: [],
                };

                if (item.type === 'image') {
                    Object.assign(cloned, {
                        image: null,
                        href: null,
                    })
                }

                if (item.type === 'columns') {
                    Object.assign(cloned, {
                        columns: [33.3333333, 33.33333, 33.33333],
                        tree: [[], [], [], [], []]
                    })
                }

                if (item.type === 'editable') {
                    Object.assign(cloned, {
                        content: '',
                    })
                }

                return cloned; 
            },
            onMove: function(evt, originalEvent){
                this.draggedType = evt.draggedContext.element.type;
                const supports = evt.to.__vue__.$parent.$parent.supports;

                /* $(evt.relatedContext.component.$el).addClass('expand'); */

                if (supports.length == 0) {
                    return true;
                }

                if (!supports.includes(evt.draggedContext.element.type)) {
                    return false;
                }
            },
            onEnd: function(evt, originalEvent){
                window.mouseBtnPressed = false;
                window.dragActive = false;
                this.draggedType = null;
                this.draggedId = null;
            },
            newId: function() {
                this.idCounter++;
                this.templateSetChanged = true
                return this.idCounter
            },
            syncUndoBuffer: function() {
            },
            syncHTML: function() {
            },
            updateComponent: function(id, data, action='update') {
                for (const [i, element] of this.blocks.entries()) {
                    if (element.id == id && i == this.currentBlock) {
                        if (action === 'update') {
                            for (let [key, value] of Object.entries(data)) {
                                if (JSON.stringify(value) !== JSON.stringify(this.blocks[i][key])) {
                                    this.componentChanged = true;
                                    break;
                                }
                            }
                            this.blocks[i] = Object.assign(this.blocks[i], data);
                            Vue.set(this.blocks, i, this.blocks[i]);
                        } else if (action === 'remove') {
                            this.blocks(i, 1);
                            this.editorActive = false;
                            this.componentChanged = true;
                            this.syncUndoBuffer();
                        } else if (action === 'duplicate') {
                            this.blocks.splice(i+1, 0, this.incrementIds(data));
                            this.componentChanged = true;
                            this.syncUndoBuffer();
                        }
                        if (this.undoIndex < this.undoHistory.length-1) {
                            this.undoHistory.splice(0, this.undoIndex);
                        }
                        this.syncHTML();
                        return
                    }
                    this.updateBranch(element.tree, id, data, i, action);
                }
            },
            updateBranch: function(branch, id, data, elemId, action){
                for (const [i, children] of branch.entries()) {
                    for (const [k, child] of children.entries()) {
                        if (child.id == id) {
                            if (action === 'update') {
                                for (let [key, value] of Object.entries(data)) {
                                    if (JSON.stringify(value) !== JSON.stringify(branch[i][k][key])) {
                                        this.componentChanged = true;
                                        break;
                                    }
                                }
                                branch[i].splice(k, 1, Object.assign(branch[i][k], data));
                                Vue.set(this.blocks, elemId, this.blocks[elemId]);
                            } else if (action === 'remove'){
                                branch[i].splice(k, 1);
                                this.editorActive = false;
                                this.componentChanged = true;
                                this.syncUndoBuffer();
                            } else if (action === 'duplicate') {
                                branch[i].splice(k+1, 0, {...this.incrementIds(data), id: this.newId()});
                                this.componentChanged = true;
                                this.syncUndoBuffer();
                            }
                            if (this.undoIndex < this.undoHistory.length-1) {
                                this.undoHistory.splice(0, this.undoIndex);
                            }
                            this.syncHTML();
                            return true;
                        } else {
                            this.updateBranch(child.tree, id, data, elemId, action);
                        }
                    }
                }
                return false;
            },
            incrementIds: function(data){
                let app = this;
                let duplicate = JSON.parse(
                    JSON.stringify(
                        data,
                        function(key, value) {
                            if (value !== null && key === 'id') {
                                return app.newId(value);
                            } else {
                                return value;
                            }
                        }
                    )
                );
                return duplicate;
            },
            registerWrapper: function() {
                delete Vue.options.components['wrapper'];
                Vue.component('wrapper', {
                    template: this.wrapper,
                });
            },
            registerComponents: function() {
                for (let [blockindex, block] of this.blocks.entries()) {
                    Vue.component(block.name, {
                        name: name,
                        description: block.description,
                        styles: block.styles,
                        props: {
                            'data': {
                                'type': Object,
                                'default': null
                            },
                            'tree': {
                                'type': Array,
                                'default': function() { return []} 
                            },
                            'description': {
                                'type': String,
                                'default': null
                            }
                        },
                        mounted: function(){
                            let containers = this.$children.filter(child => { return child.$options._componentTag=== 'container' });

                            for (var component of containers) {
                                component.$on('update', this.update);
                                component.$on('remove', this.remove);
                                component.$on('focus', this.focus);
                                component.$on('unfocus', this.unfocus);
                                component.$on('dragstart', this.dragstart);
                                component.$on('dragend', this.dragend);
                            }

                            if (this.tree.length !== containers.length) {
                                let treeContainer = [];
                                if (containers.length > 0) {
                                    for(let [index, container] of containers.entries()){
                                        treeContainer.push([]);
                                    }
                                }
                                this.$root.blocks[blockindex]['tree'] = treeContainer;
                            }

                            if (this.data.tree === undefined) {
                                return
                            }
                        },
                        methods: {
                            focus: function(id, event) {
                                this.$emit('focus', id, event);
                            },
                            unfocus: function(id, event) {
                                this.$emit('unfocus', id, event);
                            },
                            remove: function(id, event) {
                                this.$emit('remove', id, event);
                            },
                            update: function(id, key, data, event) {
                                this.$emit('update', id, key, data, event);
                            },
                            dragstart: function(id, name, event) {
                                this.$emit('dragstart', id, name, event);
                            },
                            dragend: function(event) {
                                this.$emit('dragend', event);
                            },
                        },
                        template: block.template,
                    });
                }
            },
            applyTemplateStyles: function() {
                //clear old rules
                for (var i=this.styleWriter.sheet.cssRules.length-1; i > 0; i--) {
                    this.styleWriter.sheet.deleteRule(i);
                }  
                var doc = document.implementation.createHTMLDocument("");
                var styleWriter = document.createElement("style");

                styleWriter.textContent = this.css;
                doc.body.appendChild(styleWriter);

                for (let rule of styleWriter.sheet.cssRules) {
                    var sheet = window.document.styleSheets[0];
                    this.styleWriter.sheet.insertRule('#preview '+ rule.cssText, this.styleWriter.sheet.cssRules.length);
                }
            },
        }
    }
</script>
